module.exports = __webpack_public_path__ + "img/ve.d6be56f1.svg";